<div *ngIf="!isLoading" class="user-details-container">
  <div class="headline-with-buttons">
    <div class="headline-with-status">
      <markant-platform-ui-page-header class="headline">
        {{ user.firstname }} {{ user.lastname }}
      </markant-platform-ui-page-header>

      @if (user.userType === 'TECHNICAL') {
        <markant-chip
          colorScheme="secondary"
          class="technical-chip"
          [readonly]="true"
          [label]="'organization.users.type.chip.TECHNICAL' | transloco"
          [title]="'organization.users.type.chip.TECHNICAL' | transloco"
        >
        </markant-chip>
      }

      <markant-chip
        id="categories-filter"
        [readonly]="true"
        [colorScheme]="
          UserOrganizationStatusMap[user.userOrganizationStatus].color
        "
        [label]="
          'organization.users.status.' + user.userOrganizationStatus | transloco
        "
        [title]="
          'organization.users.status.' + user.userOrganizationStatus | transloco
        "
      >
        <markant-icon
          slot="icon-leading"
          [icon]="UserOrganizationStatusMap[user.userOrganizationStatus].icon"
        >
        </markant-icon>
      </markant-chip>
    </div>

    <div *ngIf="editingMode" class="action-buttons">
      <markant-platform-button-plain
        [text]="'common.cancel' | transloco"
        [hidden]="!editingMode"
        (click)="changeEditMode(false)"
      >
      </markant-platform-button-plain>
      <div id="form-submit">
        <markant-button
          data-cy="user-button-member-save"
          [hidden]="!editingMode"
          [disabled]="submitDisabled"
          (click)="checkFormAndSave()"
        >
          <markant-icon icon="m_checkmark" slot="icon-leading"></markant-icon>
          {{ 'common.save' | transloco }}
        </markant-button>
      </div>
      <markant-tooltip
        *ngIf="submitDisabled"
        for="form-submit"
        [label]="'common.tooltipSaveNoChanges' | transloco"
        [trigger]="'mouseenter'"
      >
      </markant-tooltip>
    </div>
  </div>
  <div class="action-buttons" *ngIf="!editingMode">
    <div class="left-buttons">
      @if (currentUserIsPlatformAdmin) {
        <markant-button
          colorScheme="primary"
          variant="clear"
          [attr.id]="'organization-member-history'"
          [attr.data-cy]="'organization-member-history'"
          [routerLink]="['history']"
        >
          <markant-icon slot="icon-leading" icon="m_history"></markant-icon>
          <div>{{ 'audit.title' | transloco }}</div>
        </markant-button>
      }

      <markant-button
        *ngIf="user.userOrganizationStatus !== UserOrganizationStatus.DELETED"
        colorScheme="primary"
        variant="clear"
        id="remove-user-button-members-page"
        data-cy="user-button-delete"
        (click)="onDeleteEmployee()"
      >
        <markant-icon slot="icon-leading" icon="m_user-remove"></markant-icon>
        {{ 'user.details.deleteEmployee' | transloco }}
      </markant-button>

      @if (user.userOrganizationStatus === UserOrganizationStatus.INVITED) {
        <markant-button
          data-cy="user-button-invitation-mail-dialog"
          colorScheme="primary"
          variant="clear"
          (click)="openResendInvitationMailDialog()"
        >
          <markant-icon slot="icon-leading" icon="m_send"></markant-icon>
          {{ 'user.details.resendInvitationMail.button' | transloco }}
        </markant-button>
      } @else if (!user.verified) {
        <markant-button
          data-cy="user-button-verification-mail-dialog"
          colorScheme="primary"
          variant="clear"
          (click)="openResendEmailVerificationEmail()"
        >
          <markant-icon slot="icon-leading" icon="m_send"></markant-icon>
          {{ 'user.details.resendVerificationMail.button' | transloco }}
        </markant-button>
      }
    </div>
    <markant-button
      *ngIf="user.userOrganizationStatus !== UserOrganizationStatus.DELETED"
      data-cy="user-button-member-edit"
      class="edit-button"
      (click)="changeEditMode(true)"
    >
      <markant-icon
        class="edit-icon"
        icon="m_edit"
        slot="icon-leading"
      ></markant-icon>
      {{ 'common.edit' | transloco }}
    </markant-button>
  </div>
  <markant-platform-organization-member-details-edit
    *ngIf="editingMode; else viewMode"
    [form]="form"
    [organizationRoles]="assignableOrganizationRoles"
    [isPlatformAdmin]="currentUserIsPlatformAdmin"
    [noMailChangeReason]="noEmailChangeReason()"
  >
    <ng-container serviceroles [ngTemplateOutlet]="serviceroles"></ng-container>
    <ng-container groups [ngTemplateOutlet]="groups"></ng-container>
  </markant-platform-organization-member-details-edit>
  <ng-template #viewMode>
    <div class="user-grid">
      <div class="grid-group">
        <div class="grid-column">
          <ng-container [ngTemplateOutlet]="userdata"></ng-container>
          <ng-container [ngTemplateOutlet]="roles"></ng-container>
          <ng-container [ngTemplateOutlet]="membership"></ng-container>
        </div>
      </div>
      <div class="grid-group">
        <div class="grid-column">
          <ng-container [ngTemplateOutlet]="organization"></ng-container>
          <ng-container [ngTemplateOutlet]="address"></ng-container>
        </div>
      </div>
      <div class="grid-group">
        <div class="grid-column">
          <ng-container [ngTemplateOutlet]="serviceroles"></ng-container>
          <ng-container [ngTemplateOutlet]="groups"></ng-container>
        </div>
      </div>
    </div>
  </ng-template>

  <!--  card-templates -->
  <ng-template #userdata>
    <markant-platform-ui-card
      class="grid-item"
      [headline]="'user.details.masterdata' | transloco"
    >
      <markant-platform-ui-card-item
        [label]="'user.name' | transloco"
        [title]="fullName"
      >
        {{ fullName | defaultValue: '-' }}
      </markant-platform-ui-card-item>
      <markant-platform-ui-card-item
        [label]="'user.email.label' | transloco"
        [title]="user.email"
      >
        <div class="mail-address-wrapper">
          <span>{{ user.email | defaultValue: '-' }}</span>
          @if (user.pendingEmailUpdate) {
            <markant-chip
              id="pending-email-update-chip"
              [label]="
                'user.email.state.' +
                  (user.verified ? 'pending' : 'not-verified') | transloco
              "
              colorScheme="warning"
              [readonly]="true"
            >
              <markant-icon
                slot="markant-chip-icon-leading"
                icon="m_wait-small"
              ></markant-icon>
            </markant-chip>
            <markant-tooltip
              for="pending-email-update-chip"
              placement="top-end"
              [label]="
                'user.email.pendingTooltip'
                  | transloco: { email: user.pendingEmailUpdate }
              "
            ></markant-tooltip>
          } @else {
            <markant-chip
              [label]="'user.email.state.active' | transloco"
              colorScheme="success"
              [readonly]="true"
            >
              <markant-icon
                slot="markant-chip-icon-leading"
                icon="m_checkmark-small"
              ></markant-icon>
            </markant-chip>
          }
        </div>
      </markant-platform-ui-card-item>
      <markant-platform-ui-card-item
        [label]="'user.phone.label' | transloco"
        [title]="user.phone"
      >
        {{ user.phone | defaultValue: '-' }}
      </markant-platform-ui-card-item>
      <markant-platform-ui-card-item
        [label]="'user.language.label' | transloco"
        [title]="
          user.language && ('languageSelect.' + user.language | transloco)
        "
      >
        {{
          user.language ? ('languageSelect.' + user.language | transloco) : '-'
        }}
      </markant-platform-ui-card-item>
    </markant-platform-ui-card>
  </ng-template>

  <ng-template #address>
    <markant-platform-ui-card
      class="grid-item"
      [headline]="'user.details.address' | transloco"
    >
      <markant-platform-ui-card-item
        [label]="'address.address' | transloco"
        [title]="formatAddress(user.address)"
      >
        {{ formatAddress(user.address) | defaultValue: '-' }}
      </markant-platform-ui-card-item>
      <markant-platform-ui-card-item
        [label]="'address.country' | transloco"
        [title]="
          user.address &&
          (localeService.getLocalizedCountryName(user.address.countryCode)
            | async)
        "
      >
        {{
          user.address
            ? (localeService.getLocalizedCountryName(user.address.countryCode)
              | async)
            : '-'
        }}
      </markant-platform-ui-card-item>
    </markant-platform-ui-card>
  </ng-template>

  <ng-template #organization>
    <markant-platform-ui-card
      [headline]="'user.details.organization' | transloco"
    >
      <markant-platform-ui-card-item
        *ngIf="currentUserIsPlatformAdmin"
        [label]="'user.organization.name' | transloco"
        [title]="user.organizationName"
      >
        {{ user.organizationName | defaultValue: '-' }}
      </markant-platform-ui-card-item>
      <markant-platform-ui-card-item
        [label]="'user.department' | transloco"
        [title]="
          user.department &&
          ('register.user.departmentOptions.' + user.department | transloco)
        "
      >
        {{
          user.department
            ? ('register.user.departmentOptions.' + user.department | transloco)
            : '-'
        }}
      </markant-platform-ui-card-item>
      <markant-platform-ui-card-item
        [label]="'user.position' | transloco"
        [title]="user.position"
      >
        {{ user.position | defaultValue: '-' }}
      </markant-platform-ui-card-item>
    </markant-platform-ui-card>
  </ng-template>

  <ng-template #roles>
    <markant-platform-ui-card [headline]="'user.role' | transloco">
      <markant-chip
        *ngFor="let role of user.platformRoles ?? []; let i = index"
        [id]="'platform-role-' + i"
        [label]="'common.platformRoles.' + role | transloco"
        [readonly]="true"
        class="platform-role-chip"
        colorScheme="secondary"
      ></markant-chip>
    </markant-platform-ui-card>
  </ng-template>

  <ng-template #membership>
    @if (membershipOrigin$ | async; as membershipOrigin) {
      <markant-platform-organization-member-details-card-membership-origin
        [membershipOrigin]="membershipOrigin"
      ></markant-platform-organization-member-details-card-membership-origin>
    }
  </ng-template>

  <ng-template #serviceroles>
    <markant-platform-ui-card
      [headline]="'user.cartridgeRoleAssignment' | transloco"
    >
      <markant-icon-button
        *ngIf="reducedCartridgeRoleAssignments?.size"
        icon="m_edit"
        action-buttons
        (click)="openRoleAssignmentDialog()"
        class="button-transparent-secondary-text headline-button"
        colorScheme="primary"
      >
      </markant-icon-button>
      <ng-container
        *ngIf="!reducedCartridgeRoleAssignments?.size; else assignments"
      >
        <markant-callout
          *ngIf="showLoadRolesError"
          [colorScheme]="calloutColorScheme"
          removeable="false"
          theme="colored"
        >
          <div slot="content">
            <div class="content-wrapper flex-centered">
              <markant-icon icon="m_info"></markant-icon>
              <p>
                {{ calloutMsgKey | transloco }}
              </p>
            </div>
          </div>
        </markant-callout>
        <ng-container *ngIf="!showLoadRolesError">
          <div class="no-roles-label">
            {{ 'user.noRoles' | transloco }}
          </div>
          <a
            *ngIf="usageRights?.length"
            class="link add-roles-to-user-link"
            (click)="openRoleAssignmentDialog()"
          >
            {{ 'user.addRoles' | transloco }}
            <markant-icon
              class="link-icon"
              icon="m_arrow-right-small"
            ></markant-icon>
          </a>
        </ng-container>
      </ng-container>

      <ng-template #assignments>
        <div
          class="cartridge-role-assignment"
          *ngFor="
            let cartridgeAssignment of reducedCartridgeRoleAssignments
              | keyvalue: keepOrder;
            trackBy: trackByFn
          "
        >
          <div class="cartridge-role-assignment-label">
            {{ getCartridgeNameByVariantId(cartridgeAssignment.key) }}
          </div>

          <div class="cartridge-role-assignment-roles">
            <ng-container *ngFor="let userRole of cartridgeAssignment.value">
              <markant-chip
                class="role-chip"
                id="role-chip-{{ userRole.id }}"
                [label]="getRoleLabel(userRole)"
                colorScheme="secondary"
              >
                <markant-icon
                  *ngIf="!!userRole.suborganizationId"
                  icon="m_company"
                  slot="icon-leading"
                ></markant-icon>
                <markant-icon
                  *ngIf="!!userRole.groupId"
                  icon="m_group-small"
                  slot="icon-leading"
                ></markant-icon>
              </markant-chip>
              <markant-tooltip
                for="role-chip-{{ userRole.id }}"
                placement="bottom-start"
                [label]="getRoleLabel(userRole)"
                trigger="mouseenter focus"
                colorScheme="dark"
              ></markant-tooltip>
            </ng-container>
          </div>
        </div>
      </ng-template>
    </markant-platform-ui-card>
  </ng-template>

  <ng-template #groups>
    <markant-platform-ui-card [headline]="'user.group' | transloco">
      <ng-container *ngIf="!userGroups?.length; else groupsInOrganization">
        <div class="no-groups-label">
          {{ 'user.noGroups' | transloco }}
        </div>
        <a
          class="link add-user-to-group-link"
          *ngIf="currentUserIsAllowedToManageGroupAssignments"
          [routerLink]="['group-assignment']"
        >
          {{ 'user.addToGroup' | transloco }}
          <markant-icon
            class="link-icon"
            icon="m_arrow-right-small"
          ></markant-icon>
        </a>
      </ng-container>
      <ng-template #groupsInOrganization>
        <div id="group-cards">
          <markant-card
            class="group-card"
            [class.clickable-group-card]="
              currentUserIsAllowedToManageGroupAssignments
            "
            *ngFor="let group of userGroups"
            [routerLink]="
              currentUserIsAllowedToManageGroupAssignments
                ? ['group-assignment', group.id]
                : []
            "
            [outlined]="true"
          >
            <div slot="markant-card__headline" class="ui-card-header">
              <h5>{{ 'common.group' | transloco }} {{ group.displayName }}</h5>
              <markant-icon
                *ngIf="currentUserIsAllowedToManageGroupAssignments"
                class="icon"
                icon="m_arrow-right"
              ></markant-icon>
            </div>
            <div slot="markant-card__content">
              <div
                *ngFor="
                  let cartridgeAssignments of groupRoleAssignments[group.id];
                  trackBy: trackByFn
                "
              >
                <h5 class="group-card-cartridge-name">
                  {{ cartridgeAssignments.localizedCartridgeName }}
                </h5>
                <div class="group-card-role-container">
                  <ng-container *ngFor="let role of cartridgeAssignments.roles">
                    <markant-chip
                      class="group-card-role-name"
                      id="group-role-chip-{{ group.id }}-{{ role.id }}-{{
                        role.leistungId
                      }}"
                      colorScheme="secondary"
                      [label]="getGroupRoleLabel(role)"
                      [readonly]="true"
                    >
                      <markant-icon
                        *ngIf="!!role.suborganizationId"
                        icon="m_company"
                        slot="icon-leading"
                      ></markant-icon>
                    </markant-chip>
                    <markant-tooltip
                      for="group-role-chip-{{ group.id }}-{{ role.id }}-{{
                        role.leistungId
                      }}"
                      placement="bottom-start"
                      [label]="getGroupRoleLabel(role)"
                      trigger="mouseenter focus"
                      colorScheme="dark"
                    ></markant-tooltip>
                  </ng-container>
                </div>
              </div>
            </div>
          </markant-card>
        </div>
      </ng-template>
    </markant-platform-ui-card>
  </ng-template>
</div>

<markant-platform-modal-bridge>
  @if (isRoleAssignmentDialogOpen) {
    <markant-platform-service-roles-assignments-dialog
      [organizationId]="organizationId || ''"
      [userId]="userId"
      (closeDialog)="isRoleAssignmentDialogOpen = false"
      (reloadRoleAssignments)="triggerReload()"
    >
    </markant-platform-service-roles-assignments-dialog>
  }

  <markant-platform-approve-dialog
    *ngIf="isDeleteConfirmationDialogOpen"
    [approveCallback]="deleteConfirmationDialogCallback"
    [closeOnApprove]="true"
    [approveButtonText]="
      'user.details.role-assignment.deleteDialogApprove' | transloco
    "
    [cancelButtonText]="
      'user.details.role-assignment.deleteDialogCancel' | transloco
    "
    [headline]="deleteConformationDialogHeadlineTranslationKey | transloco"
    [text]="deleteConformationDialogTextTranslationKey | transloco"
    [(open)]="isDeleteConfirmationDialogOpen"
    (openChange)="resetDeletionCallback($event)"
  >
  </markant-platform-approve-dialog>

  <markant-platform-approve-dialog
    *ngIf="!isLoading && isResendInvitationMailDialogOpen"
    [customClassName]="'resend-mail-dialog'"
    [headline]="'user.details.resendInvitationMail.dialog.headline' | transloco"
    [text]="
      'user.details.resendInvitationMail.dialog.text'
        | transloco: { firstname: user.firstname, lastname: user.lastname }
    "
    [cancelButtonText]="'common.cancel' | transloco"
    [approveButtonText]="
      'user.details.resendInvitationMail.dialog.approve' | transloco
    "
    [(open)]="isResendInvitationMailDialogOpen"
    (isApproved)="resendInvitationMail()"
  >
  </markant-platform-approve-dialog>

  @if (!isLoading && isResendVerificationEmailOpen) {
    <markant-platform-approve-dialog
      class="organization-member-approve-dialog"
      [customClassName]="'resend-mail-dialog'"
      [headline]="
        'user.details.resendVerificationMail.dialog.headline' | transloco
      "
      [text]="
        'user.details.resendVerificationMail.dialog.text'
          | transloco: { firstname: user.firstname, lastname: user.lastname }
      "
      [cancelButtonText]="'common.cancel' | transloco"
      [approveButtonText]="'common.approve' | transloco"
      [(open)]="isResendVerificationEmailOpen"
      (isApproved)="resendVerificationMail()"
    >
    </markant-platform-approve-dialog>
  }
  <markant-platform-service-responsibility-assign-new-admin
    *ngIf="isAssignAdminForServiceBookingResponsibilityOpen"
    [owners]="owners"
    [alternativeOwners]="alternativeOwners"
    (assignNewOwnersToCartridges)="removeOrganizationAdminRole($event)"
    (closed)="closeAssignAdminForServiceBookingResponsibilityDialog()"
  >
  </markant-platform-service-responsibility-assign-new-admin>

  @if (currentUserIsPlatformAdmin && isAuditReasonDialogOpen) {
    <markant-platform-audit-reason-dialog
      (saveChanges)="saveUserWithReason($event)"
      (closed)="closeAuditReasonDialog()"
    >
    </markant-platform-audit-reason-dialog>
  }

  @if (confirmMailChangeDialogOpen()) {
    <markant-platform-approve-dialog
      class="organization-member-approve-dialog"
      [open]="true"
      [closeOnApprove]="true"
      [headline]="'user.details.confirmMailChangeDialog.headline' | transloco"
      [text]="'user.details.confirmMailChangeDialog.text' | transloco"
      [approveButtonText]="'common.confirm' | transloco"
      [cancelButtonText]="'common.cancel' | transloco"
      (openChange)="closeConfirmMailChangeDialog()"
      (calledCloseCallback)="triggerConfirmMailChange(false)"
      (isApproved)="triggerConfirmMailChange(true)"
    ></markant-platform-approve-dialog>
  }
</markant-platform-modal-bridge>

<markant-platform-organization-member-remove-user-dialog
  *ngIf="user && removeEmployeeDialogOpen"
  [organizationId]="organizationId!"
  [users]="[{ userId: userId, version: user.version }]"
  [open]="true"
  (closeChanged)="closeEmployeeRemoveDialog()"
  (removalCompleted)="userStatusToDeleted($event)"
></markant-platform-organization-member-remove-user-dialog>
